export default "__VITE_ASSET__BGSYXBJF__"